// useVersionRefresh.js
import { useEffect, useRef, useState } from 'react';

export default function useVersionRefresh({ intervalMs = 60000, basePath = '' } = {}) {
  const [outdated, setOutdated] = useState(false);
  const currentRef = useRef(null);

  useEffect(() => {
    let alive = true;

    const fetchVersion = async () => {
      try {
        // SIGURNO zaobiđi keš CDN/proxy-a:
        const url = `${basePath}version.txt?ts=${Date.now()}`;
        const res = await fetch(url, { cache: 'no-store' });
        if (!res.ok) return; // npr. 404 u dev modu
        const txt = (await res.text()).trim();
        if (!alive) return;

        if (currentRef.current && currentRef.current !== txt) {
          setOutdated(true); // detektovana nova verzija
        } else if (!currentRef.current) {
          currentRef.current = txt; // inicijalno punjenje
        }
      } catch {
        // ignorisi tihe greške (offline, sl.)
      }
    };

    fetchVersion(); // odmah
    const id = setInterval(fetchVersion, intervalMs);

    const onVis = () => { if (document.visibilityState === 'visible') fetchVersion(); };
    document.addEventListener('visibilitychange', onVis);

    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [intervalMs, basePath]);

  const reload = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg && reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      });
    } else {
      window.location.reload();
    }
  };

  return { outdated, reload };
}

